export const APPROVER_COUNT_MAX = 10

export const isApproverCount = (
	value: unknown,
	minimum: number,
): value is number =>
	typeof value === 'number' &&
	Number.isInteger(value) &&
	value >= minimum &&
	value <= APPROVER_COUNT_MAX

/** A stored system parameter is an integer from 0 to 10. */
export const isApproverMinimum = (value: unknown): value is number =>
	isApproverCount(value, 0)

export const resolveMinimumNumberOfApprovers = (value: unknown): number =>
	isApproverMinimum(value) ? value : 0

export const minimumNumberOfApproversFromJson = (
	serialized?: string | null,
): number | undefined => {
	if (!serialized) return undefined
	try {
		const parsed = JSON.parse(serialized) as {
			minimumNumberOfApprovers?: unknown
		}
		return isApproverMinimum(parsed.minimumNumberOfApprovers)
			? parsed.minimumNumberOfApprovers
			: undefined
	} catch {
		return undefined
	}
}
